import * as React from 'react';
import './index.css';
import TrackUtils from '../../utils/TrackUtils';

interface IProps {
  goodsName?: string;
  lab: any;
  stickyTitle: boolean;
}

export default class NavigationBar extends React.Component<IProps> {
  render(): React.ReactNode {
    const {
      goodsName, lab, stickyTitle
    } = this.props;
    return (
      <view className="navigation-container" style={{ backgroundColor: stickyTitle ? '#FFFFFF' : 'transparent' }}>
        <view className="header-container">
          <view className="navi-icon" />
          {stickyTitle && <view style={{ width: Mach.env.screenWidth - 88, justifyContent: 'center' }}><text className="header-title" content={goodsName} /></view>}
          <image
            className="navi-icon"
            style={{ opacity: 0 }}
            src="assets://shop/icon_good_detail_share.png"
            onClick={() => {
              TrackUtils.shareBtnMC(lab);
              console.log('点击分享当前商品');
            }}
          />
        </view>
      </view>
    );
  }
}
